import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { colors, screenLayout, headingStyle, promptStyle } from '../styles/shared.js';
import { t } from '../i18n.js';
import { cmdProceed } from '../commands.js';

@customElement('completion-screen')
export class CompletionScreen extends LitElement {
  static styles = [
    colors,
    screenLayout,
    headingStyle,
    promptStyle,
    css`
      :host {
        background: var(--color-bg-overlay);
      }
      .message {
        color: var(--color-cyan);
        font-size: 1.15rem;
      }
    `,
  ];

  @property({ type: Boolean }) accessor isTouch = false;

  render() {
    const prompt = this.isTouch ? t('complete-prompt-touch') : t('complete-prompt');

    return html`
      <div></div>
      <div>
        <div class="heading">${t('complete-heading')}</div>
        <div class="message" style="margin-top: 1.5rem">${t('complete-message')}</div>
      </div>
      <div class="prompt" @click=${cmdProceed}>${prompt}</div>
    `;
  }
}
